import Marquee from "react-fast-marquee";
import { TRUSTED } from "../data/content";
import { CUSTOM_LOGOS } from "./TrustedLogos";

export default function LogoMarquee() {
  return (
    <section data-testid="clients-marquee" className="overflow-hidden border-y border-[#E6EDF6] py-16">
      <p className="mb-10 text-center text-[12px] font-bold uppercase tracking-[0.24em] text-[#2563EB]">
        Ils nous ont fait confiance
      </p>
      <Marquee speed={40} gradient gradientColor="#ffffff" gradientWidth={120} autoFill>
        {TRUSTED.map((c, i) => (
          <img
            key={`img-${i}`}
            src={c.img}
            alt={c.name}
            loading="eager"
            decoding="sync"
            style={{ imageRendering: "auto" }}
            className={`mx-5 w-auto select-none object-contain opacity-95 transition-opacity duration-300 hover:opacity-100 [image-rendering:-webkit-optimize-contrast] sm:mx-12 ${c.h}`}
          />
        ))}
        {CUSTOM_LOGOS.map(({ key, C }) => (
          <div
            key={key}
            data-testid={`trusted-logo-${key}`}
            className="mx-5 flex h-20 items-center justify-center opacity-95 transition-opacity duration-300 hover:opacity-100 sm:mx-12 sm:h-20"
          >
            <C />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
